export default class AIGroupUserDto {

    AIGroupUserId: number;
    UserId: number;

    constructor(aiGroupUserId: number, userId: number) {
        this.AIGroupUserId = aiGroupUserId;
        this.UserId = userId;
    }
}
